// Types
import { RootState } from 'types/RootState.types';

// Config
import { isMyJLMember } from '@utils/myjl/isMyJLMember';

export const shouldApplyRewards = (state: RootState): boolean => {
  const {
    orderForm: { shouldApplyRewards = false } = {},
    user: { loyaltyType = '', myJohnLewisMembershipPending = false } = {},
  } = state ?? {};

  const isApplicableMember = isMyJLMember(loyaltyType) && !myJohnLewisMembershipPending;

  if (!isApplicableMember || !shouldApplyRewards) return false;

  return true;
};

export const shouldTriggerApplyRewards = (state: RootState): boolean => {
  const {
    app: { discountsInBasketUIEnabled = false } = {},
    orderForm: {
      appliedPromotion = false,
      customerRemovedRewards = false,
      promoCodeApplied = undefined,
      rewardInvalid = false,
    } = {},
    user: { loyaltyType = '', myJohnLewisMembershipPending = false } = {},
  } = state ?? {};

  if (discountsInBasketUIEnabled) return false;

  const shouldSkipAppliedPromotion = !appliedPromotion;
  const shouldSkipPromoCode = !promoCodeApplied || promoCodeApplied?.isRemoved === true;
  const isApplicableMember = isMyJLMember(loyaltyType) && !myJohnLewisMembershipPending;

  return (
    !customerRemovedRewards && shouldSkipAppliedPromotion && shouldSkipPromoCode && isApplicableMember && !rewardInvalid
  );
};
